function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';

var ScrollableModal = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ScrollableModal, _Component);

  function ScrollableModal() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.scrollToCssSelector = function (selector, modalBodyElement) {
      var _this$props = _this.props,
          pauseBeforeScroll = _this$props.pauseBeforeScroll,
          scrollDuration = _this$props.scrollDuration,
          scrollTo = _this$props.scrollTo;
      setTimeout(function () {
        var modalRect = modalBodyElement.getClientRects();
        var element = window.document.querySelector(".Modal__body " + selector);

        if (element) {
          var elementRect = element.getClientRects();
          var newTop = elementRect['0'].top - modalRect['0'].top;
          scrollTo(modalBodyElement, newTop, scrollDuration);
        }
      }, pauseBeforeScroll);
    };

    _this.scrollOnOpen = function (modalStructure, modalBodyElement) {
      var _this$props2 = _this.props,
          scrollSelector = _this$props2.scrollSelector,
          onModalOpen = _this$props2.onModalOpen;

      if (onModalOpen) {
        onModalOpen();
      }

      if (scrollSelector) {
        _this.scrollToCssSelector(scrollSelector, modalBodyElement);
      }
    };

    _this.scrollToTopOfModal = function (modalBodyElement) {
      var _this$props3 = _this.props,
          scrollToTop = _this$props3.scrollToTop,
          scrollDuration = _this$props3.scrollDuration;
      scrollToTop(modalBodyElement, 0, scrollDuration);
    };

    return _this;
  }

  var _proto = ScrollableModal.prototype;

  _proto.render = function render() {
    var _this$props4 = this.props,
        renderModalContent = _this$props4.renderModalContent,
        scrollTo = _this$props4.scrollTo,
        scrollToTop = _this$props4.scrollToTop,
        scrollDuration = _this$props4.scrollDuration,
        scrollSelector = _this$props4.scrollSelector,
        onModalOpen = _this$props4.onModalOpen,
        pauseBeforeScroll = _this$props4.pauseBeforeScroll,
        rest = _objectWithoutProperties(_this$props4, ["renderModalContent", "scrollTo", "scrollToTop", "scrollDuration", "scrollSelector", "onModalOpen", "pauseBeforeScroll"]);

    return /*#__PURE__*/React.createElement(Modal, _extends({
      onModalOpen: this.scrollOnOpen,
      scrollToTop: this.scrollToTopOfModal,
      isWorkflow: true
    }, rest), renderModalContent());
  };

  return ScrollableModal;
}(Component);

ScrollableModal.propTypes = _extends(_extends({}, Modal.propTypes), {}, {
  /** The time in ms that the modal will pause after open before initiating scroll. */
  pauseBeforeScroll: PropTypes.number,

  /** Duration of scroll in ms. */
  scrollDuration: PropTypes.number,

  /** A CSS selector that finds the body element to scroll to. */
  scrollSelector: PropTypes.string,

  /** Function that renders passed in modal jsx content. */
  renderModalContent: PropTypes.func,

  /** Function to be called when the modal opens. */
  onModalOpen: PropTypes.func,

  /** Function that initiates a scroll to the scrollSelector element. */
  scrollTo: PropTypes.func
});
ScrollableModal.defaultProps = _extends(_extends({}, Modal.defaultProps), {}, {
  pauseBeforeScroll: 500,
  scrollDuration: 1000,
  scrollSelector: '',
  renderModalContent: function renderModalContent() {},
  onModalOpen: function onModalOpen() {},
  scrollTo: function scrollTo() {}
});
export default ScrollableModal;
//# sourceMappingURL=ScrollableModal.js.map